import React from "react";
import PropTypes from "prop-types";
import LabelAndDots from "./LabelAndDots";

const SelectField = ({
  field,
  formData,
  handleChange,
  readOnly,
  validationErrors,
}) => {
  const isFieldReadOnly = readOnly || field.key === "managementId";
  const errorClass = validationErrors[field.key] ? "border border-red-500" : "";
  return (
    <div className="flex flex-col w-full">
      <div className="flex items-center w-full">
        <label
          className="flex items-center text-sm"
          style={{
            lineHeight: "1.2",
            whiteSpace: "nowrap",
            overflow: "hidden",
            width: "12.5em",
          }}
        >
          <LabelAndDots
            label={field.label}
            tooltip={field.tooltip}
            required={field.required && !!validationErrors[field.key]}
          />
        </label>
        <select
          name={field.key}
          className={`text-sm p-1 flex-grow size-7 ${errorClass} ${
            readOnly ? "bg-gray-100" : "border border-black"
          }`}
          value={formData[field.key] || ""}
          onChange={handleChange}
          disabled={isFieldReadOnly}
        >
          <option value="">Select an option</option>
          {field.key === "statusId"
            ? Object.entries(field.options || {}).map(([id, label]) => (
                <option key={id} value={id}>
                  {label}
                </option>
              ))
            : field.options &&
              field.options.map((option) => (
                <option key={option.key} value={option.value}>
                  {option.label}
                </option>
              ))}
        </select>
      </div>
      {validationErrors[field.key] && (
        <div className="text-red-500 text-sm mt-1 ml-2">
          {validationErrors[field.key]}
        </div>
      )}
    </div>
  );
};

SelectField.propTypes = {
  field: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  validationErrors: PropTypes.object,
};

export default SelectField;
